import {
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../serialization/SerializableProperty.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _id(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = ensureNotNull(get_serializableProperties(_this__u8e3s4));
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.k20() === '_id') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp$ret$2 = tmp$ret$1;
  var tmp = ensureNotNull(tmp$ret$2);
  return isInterface(tmp, SerializableProperty()) ? tmp : THROW_CCE();
}
//region block: exports
export {
  _id as _id10wcwzezpuldz,
};
//endregion

//# sourceMappingURL=HasIdFields.mjs.map
